import { ReplayPlan, SessionManifest } from "../domain/types";

export class RecoveryPlanner {
  constructor(
    private readonly options: {
      replayOverlapMs: number;
      replayMode: "hard" | "balanced";
    }
  ) {}

  getCommittedMs(manifest: SessionManifest): number {
    if (this.options.replayMode === "balanced") {
      return Math.max(manifest.hardCommittedMs, manifest.softCommittedMs);
    }

    return manifest.hardCommittedMs;
  }

  buildReplayPlan(
    manifest: SessionManifest,
    replayFromSeq: number
  ): ReplayPlan {
    const committedMs = this.getCommittedMs(manifest);
    const replayFromMs = Math.max(committedMs - this.options.replayOverlapMs, 0);

    return {
      committedMs,
      replayFromMs,
      replayFromSeq,
    };
  }
}
